import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { FeildPerformanceAnalysisReportSchemaObject } from "../FeildPerformanceAnalysisReportSchema";
import { validateProperty } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';

const screenCode = "FIELDPERFORMANCEANALYSISREPORT";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

export function FeildPerformanceAnalysisReport(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);

    const [feildPerformanceAnalysisReport, setFeildPerformanceAnalysisReport] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        fromDate: "",
        toDate: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        fromDate: "",
        toDate: "",
    })

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    const schema = Joi.object(FeildPerformanceAnalysisReportSchemaObject).options({ allowUnknown: true });
    const contentRowNames = ["groupName", "estateName", "divisionName", "fieldNo", "fieldName", "fieldCreator"]
    const csvHeaders = [
        { label: "Group Name", value: "groupName" },
        { label: "Estate Name", value: "estateName" },
        { label: "Division Name", value: "divisionName" },
        { label: "Field No", value: "fieldNo" },
        { label: "Field Name", value: "fieldName" },
        { label: "Field Creator", value: "fieldCreator" }
    ];

    const [reportData, setReportData] = useState([]);
    const [newReportData, setNewReportData] = useState([]);
    const [keys, setKeys] = useState([]);

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        trackPromise(getPermissions());
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
    }, [feildPerformanceAnalysisReport.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),
        )
    }, [feildPerformanceAnalysisReport.estateID])


    function clearTable() {
        setIsTableHide(true);
        setIsReportButtonsEnabled(false);
        setReportData([]);
        setFeildPerformanceAnalysisReport({
            groupID: "0",
            estateID: "0",
            divisionID: "0",
            fromDate: new Date(),
            toDate: new Date()
        })
    }

    function handleGroupChange(target) {
        validateInputs(target);
        setFeildPerformanceAnalysisReport({
            ...feildPerformanceAnalysisReport,
            groupID: target.value,
            estateID: "0",
            divisionID: "0"

        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setFeildPerformanceAnalysisReport({
            ...feildPerformanceAnalysisReport,
            estateID: target.value,
            divisionID: "0"

        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);
        setFeildPerformanceAnalysisReport({
            ...feildPerformanceAnalysisReport,
            divisionID: target.value
        });
    }

    function handleSearchFromDateChange(target) {
        validateInputs(target);
        setFeildPerformanceAnalysisReport({
            ...feildPerformanceAnalysisReport,
            fromDate: target.value
        });
    }

    function handleSearchToDateChange(target) {
        validateInputs(target);
        setFeildPerformanceAnalysisReport({
            ...feildPerformanceAnalysisReport,
            toDate: target.value
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, FeildPerformanceAnalysisReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];
        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'FIELDPERFORMANCEANALYSISREPORT');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromToken();
        setFeildPerformanceAnalysisReport({
            ...feildPerformanceAnalysisReport,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const result = await services.GetAllOperationEntityByGroupID(feildPerformanceAnalysisReport.groupID);
        setEstates(result);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(feildPerformanceAnalysisReport.estateID);
        setDivisions(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {
        e.preventDefault();
        setIsTableHide(true);
        setButtonHide(true);
        getSelectedDropdownValuesForReport(feildPerformanceAnalysisReport);
        setIsTableHide(true);

        const result = await services.GetBlockPluckingReportData(feildPerformanceAnalysisReport);
        const userList = await services.GetActiveAspNetUser(feildPerformanceAnalysisReport.groupID, feildPerformanceAnalysisReport.estateID);

        setReportData(result);

        let DataArray = [...result]

        DataArray.forEach(x => {
            let found = userList.data.filter(item => item.aspNetUserId === x.fieldOfficer)
            if (found.length > 0) {
                let FirstName = found[0].firstName;
                let secondName = found[0].lastName;
                let fullname = FirstName + " " + secondName;
                x.fieldOfficerName = fullname;
            }
        })
        setNewReportData(DataArray);
        if (result.length > 0) {
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }
        setButtonHide(false);
        setIsReportButtonsEnabled();
    }

    function createFile() {
        var settings = {
            sheetName: ' FPA report',
            fileName: 'FPAReport',
            writeOptions: {}
        }
        var copyOfCsv = [...newReportData]
        var newRow1 = {
            groupName: "Group :" + groups[feildPerformanceAnalysisReport.groupID],
            estateName: "Estate : " + estates[feildPerformanceAnalysisReport.estateID],
            divisionName: feildPerformanceAnalysisReport.divisionID == "0" ? "Division : All Division" :
                "Division : " + divisions[feildPerformanceAnalysisReport.divisionID],
            fromDate: "From : " + feildPerformanceAnalysisReport.fromDate,
            toDate: "To : " + feildPerformanceAnalysisReport.toDate
        }
        copyOfCsv.push({}, {}, newRow1)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            fromDate: searchForm.fromDate,
            toDate: searchForm.toDate
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Feild Performance Analysis Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={feildPerformanceAnalysisReport.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID"> Estate * </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={feildPerformanceAnalysisReport.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">CollectionPoint </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={feildPerformanceAnalysisReport.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">-- Select Division --</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            onChange={(e) => handleSearchFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            onChange={(e) => handleSearchToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                    <input type="reset" className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={clearTable}
                                    />
                                </div>
                            </form>
                            {isTableHide ? null :
                                <div>
                                    <br />
                                    <br />
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Estate Name</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Division Name</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Field No</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Field Name</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>AEM Officer</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {newReportData.slice(page * limit, page * limit + limit).map((row, i) => (
                                                    <TableRow key={i}>
                                                        <TableCell component="th" scope="row" align="center"> {row.estateName}</TableCell>
                                                        <TableCell component="th" scope="row" align="center"> {row.divisionName}</TableCell>
                                                        <TableCell component="th" scope="row" align="center"> {row.fieldNo}</TableCell>
                                                        <TableCell component="th" scope="row" align="center"> {row.fieldName}</TableCell>
                                                        <TableCell component="th" scope="row" align="center"> {row.fieldCreator}</TableCell>
                                                    </TableRow>
                                                )
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            component="div"
                                            count={reportData.length}
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handleLimitChange}
                                            page={page}
                                            rowsPerPage={limit}
                                            rowsPerPageOptions={[5, 10, 25]}
                                        />
                                    </TableContainer>
                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                        <ReactToPrint
                                            documentTitle={"Feild Performance Analysis Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"
                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={newReportData}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
